// Board-related translations
const boardsTranslations = {
    board_create_title: {
        th: "สร้างโพสต์ใหม่",
        en: "Create New Post",
        ja: "新規投稿作成",
    },
    board_btn_create: {
        th: "สร้างโพสต์",
        en: "Post",
        ja: "投稿する",
    },
    board_title: {
        th: "หัวข้อ",
        en: "Title",
        ja: "タイトル",
    },
    board_content: {
        th: "เนื้อหา",
        en: "Content",
        ja: "内容",
    },
    wysiwyg_content_placeholder: {
        th: "เขียนเนื้อหาที่นี่...\n\n💡 วาง URL ได้เลย (ระบบจะตรวจจับอัตโนมัติ)\n✅ ถ้าเป็นลิงก์ SNS (Facebook / YouTube ฯลฯ) จะถูกเพิ่มไปที่ SNS Links\n\n❌ โค้ดฝัง (HTML เช่น iframe) จะถูกลบออกโดยอัตโนมัติเพื่อความปลอดภัย\n\n📷 วางรูปภาพโดยตรง (Ctrl+V) หรือใช้ปุ่มเครื่องมือ\n📎 แนบไฟล์เพิ่มเติม: ใช้ปุ่มด้านล่าง",
        en: "Write your content here...\n\n💡 Paste URLs directly (auto-detected)\n✅ SNS URLs (Facebook / YouTube etc.) will appear in SNS Links\n\n❌ Embed HTML (e.g., iframe) is automatically removed for safety\n\n📷 Paste images directly (Ctrl+V) or use toolbar buttons\n📎 Additional attachments: Use buttons below",
        ja: "ここに内容を書いてください...\n\n💡 URLをそのまま貼り付けOK（自動検出されます）\n✅ SNSのURL（Facebook / YouTube 等）は SNS Links に表示されます\n\n❌ 埋め込みHTML（iframe等）は安全のため自動的に削除されます\n\n📷 画像を直接貼り付け (Ctrl+V) またはツールバーボタンを使用\n📎 追加の添付ファイル: 下のボタンを使用",
    },
    board_btn_submit: {
        th: "โพสต์ด้วยเนื้อหานี้",
        en: "Submit Post",
        ja: "この内容で投稿",
    },
    board_confirm_title: {
        th: "ยืนยันเนื้อหาการโพสต์",
        en: "Confirm Post Content",
        ja: "投稿内容の確認",
    },
    board_btn_back: {
        th: "ย้อนกลับ",
        en: "Back",
        ja: "戻る",
    },
    board_dexcription: {
        th: "คำอธิบายบอร์ด",
        en: "Board Description",
        ja: "掲示板の説明",
    },
    default_board_name: {
        th: "บอร์ดทั่วไป",
        en: "General Board",
        ja: "一般掲示板",
    },
    create_new_post: {
        th: "สร้างโพสต์ใหม่",
        en: "Create New Post",
        ja: "新規投稿",
    },
    login_required_to_post: {
        th: "โพสต์ใหม่ต้อง",
        en: "Login required to",
        ja: "投稿するには",
    },
    before: {
        th: "ก่อน",
        en: "post",
        ja: "が必要です",
    },
    no_posts_yet: {
        th: "ยังไม่มีโพสต์",
        en: "No posts yet",
        ja: "投稿がありません",
    },
    board_tab_form: {
        th: "ฟอร์มเข้า",
        en: "Input Form",
        ja: "入力フォーム",
    },
    board_tab_preview: {
        th: "ตัวอย่าง",
        en: "Preview",
        ja: "プレビュー",
    },
    // Review related translations
    review_items: {
        th: "รายการประเมิน",
        en: "Review Items",
        ja: "評価項目",
    },
    product_name: {
        th: "ชื่อสินค้า",
        en: "Product Name",
        ja: "商品名",
    },

    // Board type labels
    board_type_general: {
        th: "ทั่วไป",
        en: "General",
        ja: "一般",
    },
    board_type_news: {
        th: "ข่าว",
        en: "News",
        ja: "ニュース",
    },
    board_type_article: {
        th: "บทความ",
        en: "Article",
        ja: "記事",
    },
    board_type_review: {
        th: "รีวิว",
        en: "Review",
        ja: "レビュー",
    },
};

export { boardsTranslations };
